import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';

import {ArrowRightIcon} from '@amblique/king-living/app/components/icons';
import {ensureArray} from '@amblique/king-living/app/utils/utils';
import BaseLink from '@amblique/king-living/app/components/link';
import {
  Box, Text, useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui';

import {
  MenuItemContent,
} from '@amblique/king-living/app/components/mega-menu/shared/menu-item-container';
import {
  formatShopAllLabel,
  getFeaturedLink,
  getLinkUrl,
  getNavLinkAnchorProps,
} from '@amblique/king-living/app/utils/navigation-primary-tabs';

export const MegaMenuSubcategoryPanel = ({
  category,
  transform = 'translateX(100%)',
  zIndex = 3,
  ...props
}) => {
  const intl = useIntl();
  const styles = useMultiStyleConfig('MegaMenu', {isMobile: true});

  const submenuItems = ensureArray(category?.submenuCollection?.items).filter(Boolean);
  const featuredLink = getFeaturedLink(category);
  const featuredHref = getLinkUrl(featuredLink);
  const featuredLabel = formatShopAllLabel(category, intl.formatMessage);

  return (
    <Box
      className="mega-menu-subcategory-panel"
      {...styles.mobileSubcategoryPanel}
      transform={transform}
      zIndex={zIndex}
      {...props}
      sx={{
        willChange: 'transform',
        ...props.sx,
      }}
    >
      <Box className="mega-menu-subcategory-panel-wrapper" {...styles.mobileSubcategoryPanelWrapper}>
        <Box className="mega-menu-subcategory-panel-wrap" {...styles.mobileSubcategoryPanelWrap}>
          {featuredLabel && featuredHref && (
            <Box className="mega-menu-subcategory-panel-shop-all-link-wrapper" {...styles.shopAllLinkWrapper}>
              <BaseLink
                className="shop-all-link"
                {...getNavLinkAnchorProps(featuredLink, featuredHref)}
              >
                <Text as="span">{featuredLabel}</Text>
                <ArrowRightIcon aria-hidden {...styles.shopAllTitleIcon} />
              </BaseLink>
            </Box>
          )}
          <MenuItemContent
            isMobile={true}
            menuItem={category}
            submenuItems={submenuItems}
          />
        </Box>
      </Box>
    </Box>
  );
};

MegaMenuSubcategoryPanel.displayName = 'MegaMenuSubcategoryPanel';
MegaMenuSubcategoryPanel.propTypes = {
  category: PropTypes.object.isRequired,
  onBackClick: PropTypes.func,
  transform: PropTypes.string,
  zIndex: PropTypes.number,
};
